var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_713_2777)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.499 0C15.2195 0.0884995 13.724 0.907495 12.8525 1.97399C12.0575 2.94148 11.4035 4.37847 11.6585 5.77497C13.0565 5.81847 14.501 4.97997 15.338 3.89548C16.121 2.88598 16.7135 1.45799 16.499 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5554 8.05192C20.327 6.51143 18.6005 5.61743 16.97 5.61743C14.8175 5.61743 13.907 6.64793 12.4115 6.64793C10.8695 6.64793 9.69801 5.62043 7.83652 5.62043C6.00803 5.62043 4.06105 6.73792 2.82655 8.64891C1.09106 11.3399 1.38806 16.3994 4.20055 20.7088C5.20704 22.2508 6.55103 23.9848 8.30902 23.9998C9.87351 24.0148 10.3145 22.9963 12.434 22.9858C14.5535 22.9738 14.9555 24.0133 16.517 23.9968C18.2765 23.9833 19.694 22.0618 20.7004 20.5198C21.4219 19.4144 21.6904 18.8579 22.2499 17.6099C18.1805 16.0604 17.528 10.2734 21.5554 8.05192Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_713_2777"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/Apple-Logo.7f40cc73c6bb0c94fd156522d5ee5940.svg";
export { ForwardRef as ReactComponent };